<template>
  <div class="single-page">
    <keep-alive>
      <router-view v-loading="inputDataLoading"></router-view>
    </keep-alive>
    <div class="content-map" :class="{'hide-map': ['/home/single', '/single_home/single'].indexOf(path) === -1}">
      <chart_map_pre></chart_map_pre>
    </div>
    <switch_map_btn :mapPathName="path.indexOf('/home/single') > -1 ? 'single' : 'single.single'"></switch_map_btn>
  </div>
</template>

<script>
import ChartMapPre from '@/view/map_pre'
import SwitchMapBtn from '@/components_bit/SwitchMapBtn'

export default {
  components: {
    switch_map_btn: SwitchMapBtn,
    chart_map_pre: ChartMapPre
  },
  computed: {
    inputDataLoading: {
      get () {
        return this.$store.getters.inputDataLoading
      }
    },
    path: {
      get () {
        return this.$store.state.route.path
      }
    }
  },
  created () {
    this.$store.dispatch('loadInputData')
    this.$store.dispatch('loadLocationData')
  }
}
</script>

<style scoped lang="less">
@import '../../style/base.less';
.hide-map {
  z-index: -1;
}
.content-map {
  position: absolute;
  top: 6.13em;
  bottom: 0;
  left: 0;
  right: 0;
}
.page-top {
  z-index: 4;
}
.single-page {
  flex:1;
}
</style>



// WEBPACK FOOTER //
// single.vue?3163470f